import {
  Button,
  Container,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from '@mui/material';
import { Helmet } from 'react-helmet-async';

import CustomBreadcrumbs from '@/commons/custom-breadcrumbs';
import ListPage from '@/components/Table';
import { useModal } from '@/hooks/useModal';
import { PATH_DASHBOARD } from '@/routes/paths';
import { calculateAllPriceProducts, getProductsService } from '@/services';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { translates } from '@/utils/translate';
import { ListActionsProducts } from '../actions-list';
import { Product } from '../types';
import { TABLE_HEAD_PRODUCTS } from '../utils/constants';

export default function ProductListPage() {
  const navigate_products: any = {
    view: PATH_DASHBOARD.products.view,
    edit: PATH_DASHBOARD.products.edit,
  };
  const title = 'Products';
  const links = [
    { name: translates.dashboard, href: PATH_DASHBOARD.root },
    { name: translates.products, href: PATH_DASHBOARD.products.list },
  ];
  const { isLoading, data } = useQuery({
    queryKey: ['products'],
    queryFn: getProductsService,
    select: (values) => values?.map((value: Product) => ({
      ...value,
      id: value.product.id,
      categories: value.product.categories[0],
      lines: value.product.lines[0],
    })),
  });

  const queryClient = useQueryClient();

  const { mutate } = useMutation({
    mutationKey: ['products'],
    mutationFn: calculateAllPriceProducts,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['canceled-products'] });
      handleChange();
    },
  });
  const handleCalculatePrice = async () => {
    await mutate();
  };
  const { handleChange, open } = useModal();
  return (
    <>
      <Helmet>
        <title>
          {' '}
          {import.meta.env.VITE_TITLE_BUSINESS}: {title} List
        </title>
      </Helmet>

      <Container maxWidth={false}>
        <CustomBreadcrumbs
          heading={`${translates.list} ${title} `}
          links={links}
          action={[]}
        />

        <ListPage<Product, number>
          data={data}
          navigateHandle={navigate_products}
          actions={ListActionsProducts}
          isLoading={isLoading}
          dataStruct={TABLE_HEAD_PRODUCTS}
        />
      </Container>

      <Dialog open={open} onClose={handleChange}>
        <DialogTitle>{translates.updateProductPrices}</DialogTitle>
        <DialogContent>
          <Typography variant="body2">{translates.messageUpdateProducts}</Typography>
          <DialogActions>
            <Button onClick={handleCalculatePrice} disabled={false}>
              {translates.change}
            </Button>
            <Button onClick={handleChange} disabled={false}>
              {translates.cancel}
            </Button>
          </DialogActions>
        </DialogContent>
      </Dialog>
    </>
  );
}
